import { useMapEvents } from 'react-leaflet';

/**
 * Reports the mouse pointer's map coordinate without rendering anything. The editor uses this value to
 * show a square or circle preview before the user clicks to place it.
 *
 * @param {Object} props
 * @param {Function} props.onPointerChange Receives the current map coordinate, or null on exit.
 * @returns {null}
 */
const MapPointerTracker = ({ onPointerChange }) => {
  useMapEvents({
    mousemove: (event) => onPointerChange(event.latlng),
    mouseout: () => onPointerChange(null),
  });

  return null;
};

export default MapPointerTracker;
